<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter sigilNotInTOC" id="heading_id_2"> <br/>
<br/></h2>
<p class="indent"><em>When you are small and need help, you run to your parents. When you get older... If someone threatens you, you call a cop. In prison there is no one to turn to, no one to solve your problems for you. If you go to the guards, you will be known as a snitch and that can get you killed. Believe me, the guy demanding that you drop your drawers isn’t going to be a good sport and simply let you walk away. You must be willing to fight or you must give in.</em></p>
<p class="right2">—Leavenworth Chief Psychologist Thomas White, PhD</p>
<p class="indent1"><em>Sometimes, I think about what it would be like to just go into a bank and blow the head off the first teller I see. I know that I am capable of that; I mean, any criminal is capable of that, and long-term prisoners can kill easier than most people, because you are around the dregs so much and for so long that you forget the worth of a human life. You think all humans are dregs.</em></p>
<p class="right2">—Leavenworth inmate William Post</p>
<p class="indent1"><em>The hopeless despair on the Rock is reflected in the faces and actions of almost all of the inmates. Watching those men from day to day slowly giving up hopes is truly a pitiful sight, even if you are one of them.</em></p>
<p class="right2">—Roy Gardner, Alcatraz inmate #110</p>
<p class="indent1"><em>Nobody ever did, or ever will, escape the consequences of his choices.</em></p>
<p class="right2">—Alfred A. Montapert</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quotes.vue?6564c520